// this file added by Bearer Web Developer
const formatSecondsToMMSS = (totalSeconds: number): string => {
  if (totalSeconds >= 3600) {
    const hours = Math.floor(totalSeconds / 3600);
    const remainedSeconds = totalSeconds % 3600; // remaining seconds after extracting hours
    const paddedHours = String(hours).padStart(2, "0");
    const minutes = Math.floor(remainedSeconds / 60);
    const seconds = Math.floor(remainedSeconds % 60);
    let paddedMinutes = String(minutes).padStart(2, "0");
    let paddedSeconds = String(seconds).padStart(2, "0");
    return `${paddedHours}:${paddedMinutes}:${paddedSeconds}`;
  } else {
    const minutes = Math.floor(totalSeconds / 60);
    const seconds = Math.floor(totalSeconds % 60);
    const paddedMinutes = String(minutes).padStart(2, "0");
    const paddedSeconds = String(seconds).padStart(2, "0");
    return `${paddedMinutes}:${paddedSeconds}`;
  }
};
export default formatSecondsToMMSS